/* eslint-disable react/no-danger */
import './style.scss';
import React, {Component} from 'react';

const convert = (transform) => {
    return Object.keys(transform).map((key) => {
        const attr = Object.keys(transform[key])
            .map(k => transform[key][k])
            .join(',');
        return `${key}(${attr})`;
    }).join(' ');
};

class Icon extends Component {
    render() {
        const {
            size = 36, fill, forcefill = false, svgpath, extraClass = '', className = '',
        } = this.props;
        const scale = size / 1024;
        const transform = {
            translate: { x: 0, y: 0 },
            scale: { x: scale, y: scale },
        };

        const style = {
            width: size,
            height: size,
            display: 'inline-block',
            overflow: 'hidden',
        };
        const classList = ['Icon'];
        classList.push(extraClass);
        classList.push(className);

        // 处理颜色
        let renderPath = svgpath;
        if (fill && forcefill && renderPath) {
            const matchedPath = renderPath.match(/<path[^>]*>/g);
            (matchedPath || []).forEach((path) => {
                if (path.indexOf('fill') > -1) {
                    renderPath = renderPath.replace(/fill="[^"]*"/g, `fill="${fill}"`);
                } else {
                    renderPath = renderPath.replace(/<path/g, `<path fill="${fill}"`);
                }
            });
        }

        return (
            <div
                style={style}
                className={classList.join(' ')}
            >
                <svg
                    width="1024"
                    height="1024"
                    viewBox="0 0 1024 1024"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <g className="transform-group">
                        <g
                            transform={convert(transform)}
                            dangerouslySetInnerHTML={{ __html: renderPath }}
                        />
                    </g>
                </svg>
            </div>
        );
    }
}

export default Icon;
